const ArrowRight = ({ className, style, ...props }) => (
  <span
    className={`arrow-right db animate ${className ? className : ``}`}
    style={{ ...style }}
    {...props}
  >
    <span aria-hidden="true" className="arrow-line animate">
      <span className="arrow" />
    </span>
  </span>
)

export default ArrowRight

/*
 *
 * Imports
 * 
 */

import React from 'react'



// WEBPACK FOOTER //
// ./src/components/ArrowRight.js